import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Box } from '@/shared/ui/box';
import { Image } from '@/shared/ui/image';
import * as Dialog from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { withBreakpointsSlice } from '@/shared/providers/utils/with-breakpoints-slice';
import {
  CloseIconImage,
  StyledAlertDialogOverlay,
  StyledAlertDialogContent,
} from '@/features/auth-managment/styles';
import { FullForm } from '@/features/wallet-managment/ui/fiat-form/ui/full-form';
import { PreparedBonuses } from '@/features/news-managment/ui/prepared-bonuses';

const MotivationalModal = ({ mobileLandscape, visible, onClose }) => {
  return (
    <Dialog.Root open={visible}>
      <Dialog.Portal>
        <VisuallyHidden>
          <Dialog.Title>WalletManagment</Dialog.Title>
        </VisuallyHidden>
        <StyledAlertDialogOverlay onClick={onClose} />
        <StyledAlertDialogContent
          style={{ background: !mobileLandscape && 'none' }}
        >
          <Box
            $display="flex"
            style={{ position: 'relative' }}
            $height={'100%'}
          >
            {!mobileLandscape && (
              <Box $width={'362px'} $transition="width 0.3s ease">
                <AnimatePresence mode="wait">
                  <motion.div
                    key="welcome-banner"
                    initial={{ x: 100, opacity: 0 }}
                    animate={{
                      x: 0,
                      opacity: 1,
                      transition: {
                        type: 'spring',
                        damping: 25,
                        stiffness: 120,
                        duration: 0.4,
                      },
                    }}
                    exit={{
                      x: 100,
                      opacity: 0,
                      transition: {
                        type: 'spring',
                        damping: 25,
                        stiffness: 120,
                        duration: 0.3,
                      },
                    }}
                    style={{
                      width: '362px',
                      position: 'absolute',
                      left: 0,
                      top: 0,
                      height: '100%',
                    }}
                  >
                    <PreparedBonuses />
                  </motion.div>
                </AnimatePresence>
              </Box>
            )}

            <motion.div
              initial={{ opacity: 0 }}
              animate={{
                opacity: 1,
                transition: { duration: 0.3 },
              }}
              exit={{
                opacity: 0,
                transition: { duration: 0.2 },
              }}
              style={{
                width: mobileLandscape ? '100%' : '362px',
                position: 'relative',
                marginLeft: mobileLandscape ? 0 : '10px',
                height: '100%',
              }}
            >
              <Box
                $backgroundColor="#131315"
                $padding="18px"
                $maxHeight={mobileLandscape ? '100%' : '635px'}
                $overflow="scroll"
                $gap="18px"
                $display="flex"
                $flexDirection="column"
              >
                <Box onClick={onClose} $textAlign="right" $cursor="pointer">
                  <Image
                    width={32}
                    height={32}
                    src="/images/icons/close-dialog.svg"
                  />
                </Box>

                <FullForm
                  handleSubmit={() => console.log(12)}
                  settings={null}
                  isLocked={false}
                  modBonuse={mobileLandscape}
                />
              </Box>
            </motion.div>
          </Box>
        </StyledAlertDialogContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

const MotivationalModalWithBreakpointSlice = withBreakpointsSlice(
  MotivationalModal,
  ({ mobileLandscape }) => ({ mobileLandscape })
);

export { MotivationalModalWithBreakpointSlice as MotivationalModal };
